var _rect, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    x: 18,
    y: 18,
    fill: "#0075ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.66,33.248c3.629,0,6.58,2.877,6.58,6.509c0,3.706-2.951,6.583-6.58,6.583c-3.783,0-6.66-2.877-6.66-6.583 C29,36.125,31.877,33.248,35.66,33.248z M29.604,52.088H41.71v41.919H29.604V52.088z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,66.012v27.996H77.894V69.493c0-5.144-2.273-7.492-6.66-7.492c-4.313,0-7.264,3.028-7.264,7.19v24.816H51.863V52.088 h9.383l1.208,5.902h0.228c2.495-3.934,6.888-6.962,12.636-6.962C84.4,51.029,90,56.629,90,66.012z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a4e2f1",
    d: "M35.66,29.248c3.629,0,6.58,2.877,6.58,6.509c0,3.706-2.951,6.583-6.58,6.583 c-3.783,0-6.66-2.877-6.66-6.583C29,32.125,31.877,29.248,35.66,29.248z M29.604,48.088H41.71v41.919H29.604V48.088z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4e2f1",
    d: "M90,62.012v27.996H77.894V65.493c0-5.144-2.273-7.492-6.66-7.492c-4.313,0-7.264,3.028-7.264,7.19 v24.816H51.863V48.088h9.383l1.208,5.902h0.228c2.495-3.934,6.888-6.962,12.636-6.962C84.4,47.029,90,52.629,90,62.012z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c43db511c0f251d3a5473221ebe70a5d.svg";
export { ForwardRef as ReactComponent };